module.exports = __webpack_public_path__ + "media/images/emblems/Neggio-coat_of_arms-87040ba1efb75b1c1374057d380951a0.svg";